import {
  disputeQueueStates,
  type DisputeQueueState,
} from "@redotech/redo-dispute-common/dispute-queue-state";
import { disputeViewSchema } from "@redotech/redo-dispute-common/dispute-view-definition";
import {
  disputeReason,
  disputeSortableColumns,
  disputeStatus,
} from "@redotech/redo-dispute-db-schema/dispute-definition";
import { SortDirectionSchema } from "@redotech/redo-views-common/table";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

const disputeListSortColumns = [
  ...disputeSortableColumns,
  "queuePriority",
] as const;

export const getDisputes = {
  name: "getDisputes" as const,
  input: z.object({
    statuses: z.array(z.enum(disputeStatus)).optional(),
    queueStates: z.array(z.enum(disputeQueueStates)).optional(),
    reasons: z.array(z.enum(disputeReason)).optional(),
    startDate: zExt.plainDate().optional(),
    endDate: zExt.plainDate().optional(),
    limit: z.number().int().min(1).max(200).optional(),
    offset: z.number().int().min(0).optional(),
    sortBy: z.enum(disputeListSortColumns).optional(),
    sortDirection: SortDirectionSchema.optional(),
  }),
  output: z.object({
    disputes: z.array(disputeViewSchema),
    total: z.number().int(),
  }),
};

export type MerchantDisputeQueueState = DisputeQueueState;
